import { isBoolean, isNil } from 'lodash'
import { ref } from 'vue'

export const useLoadingState = (initialValue = false) => {
  const isLoading = ref(initialValue)

  const toggleLoading = flag => {
    if (isNil(flag)) {
      isLoading.value = !isLoading.value
      return
    }

    if (!isBoolean(flag)) {
      throw new TypeError('useLoadingState: flag must be a boolean')
    }

    isLoading.value = flag
  }

  return { isLoading, toggleLoading }
}
